import React from 'react';
import { CommissionTermsProps } from './NetworkRegisterInterface/NetworkRegisterInterface';
import CommissionTermsComponent from 'components/CommissionTerms/CommissionTerms';

const CommissionTerms: React.FC<CommissionTermsProps> = ({ commisionTerms = [] }) => {
  const termsOptions = commisionTerms.map((commissionTerm: any) => ({
    ...commissionTerm,
    value: commissionTerm.id,
  }));

  return <CommissionTermsComponent terms={termsOptions} />;
};

export default CommissionTerms;
